import { HTTPMethod } from 'utils/HTTPUtils';
import { authenticationHeaders } from 'networking/mindfeed/utils/authenticationHeaders';
import { routes } from 'networking/mindfeed/constants/api';
import { apiFetch } from 'networking/mindfeed/utils/apiClient';
import { AppNotification, NotificationId } from 'models/AppNotification';

// The signed-in user's notifications, newest first, with each actor's name
// and photo. The API returns the latest 100.
export const getNotifications = async (): Promise<AppNotification[]> => {
  const response = await apiFetch<{ data: AppNotification[] }>(
    routes.notifications.withActors,
    {
      method: HTTPMethod.GET,
      headers: await authenticationHeaders(),
    },
  );
  return response?.data ?? [];
};

// How many notifications the user hasn't seen yet.
export const getUnseenNotificationsCount = async (): Promise<number> => {
  const response = await apiFetch<{ count: number }>(
    routes.notifications.unseenCount,
    {
      method: HTTPMethod.GET,
      headers: await authenticationHeaders(),
    },
  );
  return response?.count ?? 0;
};

// Marks one notification read or unread.
export const setNotificationRead = async (
  notificationId: NotificationId,
  read: boolean,
): Promise<void> =>
  apiFetch<void>(routes.notifications.byId(notificationId), {
    method: HTTPMethod.PATCH,
    headers: await authenticationHeaders(),
    body: JSON.stringify({ read }),
  });

// Marks every notification read, including ones past the first 100.
export const markAllNotificationsRead = async (): Promise<void> =>
  apiFetch<void>(routes.notifications.all, {
    method: HTTPMethod.PATCH,
    headers: await authenticationHeaders(),
    body: JSON.stringify({ read: true }),
  });

// Marks every notification seen, which clears the badge but keeps each
// row's unread highlight.
export const markAllNotificationsSeen = async (): Promise<void> =>
  apiFetch<void>(routes.notifications.all, {
    method: HTTPMethod.PATCH,
    headers: await authenticationHeaders(),
    body: JSON.stringify({ seen: true }),
  });

export const deleteNotification = async (
  notificationId: NotificationId,
): Promise<void> =>
  apiFetch<void>(routes.notifications.byId(notificationId), {
    method: HTTPMethod.DELETE,
    headers: await authenticationHeaders(),
  });
